import { CUSTOM_PUSH } from 'modules/sendingPlatforms/constants';
import { IntegrationCard } from './IntegrationCard';

export const PushIntegrationCard = () => {
  return <IntegrationCard sendingPlatform={CUSTOM_PUSH}></IntegrationCard>;
};
